var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_vm._v(" Welcome "+_vm._s(_vm.authenticatedUser.first_name)+" "+_vm._s(_vm.authenticatedUser.last_name)+", "+_vm._s(_vm.authenticatedUser.branch.name)+" Branch ")])
}
var staticRenderFns = []

export { render, staticRenderFns }